package com.example.positionahead.ui.theme

import androidx.compose.ui.graphics.Color

fun colorFromHex(hex: String): Color {
    val cleaned = hex.trim().removePrefix("#")
    if (cleaned.length != 6) return Color(0xFF1B8A5A)
    val rgb = cleaned.toLongOrNull(16) ?: return Color(0xFF1B8A5A)
    return Color(0xFF000000 or rgb)
}
